"use client";

import { FooterSection } from "@/cms/models";
import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/sharp-light-svg-icons";

const DefaultPartner: React.FC<FooterSection> = ({ app }) => {
  const [showDetails, setShowDetails] = useState<boolean>(false);

  const customerAndParties = app.appData.resourceGroup?.customerAndParties;

  return (
    <div className="pt-4 z-10 homepage-text-smflex text-[var(--partner-text-color)] bg-[var(--partner-bg-color)]  ">
      <div className="max-w-screen-2xl w-full text-[var(--partner-text-color)] flex flex-1 flex-col">
        <button
          className="flex gap-1 items-center text-footer-content"
          onClick={() => setShowDetails(!showDetails)}
        >
          Samarbejdsaftaler
          <FontAwesomeIcon
            className={`size-4 transition-transform duration-300 ${showDetails ? "rotate-90" : ""}`}
            icon={faChevronRight}
          />
        </button>
        <div
          className={`flex flex-col gap-4 py-4 transition-height duration-300 ease-in-out ${showDetails ? "" : "hidden"}`}
        >
          {/* <div className="grid grid-cols-12 gap-1">
            <div className="truncate col-span-5 md:col-span-4 xl:col-span-2">Realkreditinstitut:</div>
            <div className="col-span-7 md:col-span-8 xl:col-span-10">{customerAndParties?.affiliateOrCollaborationRealcreditInstituteMF?.value}</div>
            <div className="truncate col-span-5 md:col-span-4 xl:col-span-2">Pengeinstitut:</div>
            <div className="col-span-7 md:col-span-8 xl:col-span-10">{customerAndParties?.affiliateOrCollaborationMoneyInstituteMF?.value}</div>
            <div className="truncate col-span-5 md:col-span-4 xl:col-span-2">Forsikringsselskab:</div>
            <div className="col-span-7 md:col-span-8 xl:col-span-10">{customerAndParties?.affiliateOrCollaborationInsuranceCompanyMF?.value}</div>
            <div className="truncate col-span-5 md:col-span-4 xl:col-span-2">Andre:</div>
            <div className="col-span-7 md:col-span-8 xl:col-span-10">{customerAndParties?.affiliateOrCollaborationOthersMF?.value}</div>
          </div> */}
          <div className="grid grid-cols-[13rem_1fr] md:grid-cols-[15rem_1fr] gap-1">
            <div>Realkreditinstitut:</div>
            <div>{customerAndParties?.affiliateOrCollaborationRealcreditInstituteMF?.value}</div>
            <div>Pengeinstitut:</div>
            <div>{customerAndParties?.affiliateOrCollaborationMoneyInstituteMF?.value}</div>
            <div>Forsikringsselskab:</div>
            <div>{customerAndParties?.affiliateOrCollaborationInsuranceCompanyMF?.value}</div>
            <div>Andre:</div>
            <div>{customerAndParties?.affiliateOrCollaborationOthersMF?.value}</div>
          </div>
          <div className="flex flex-col gap-4">
            <div>Vederlag/provision/rabat modtager for fremskaffelse af:</div>
            <div className="grid grid-cols-[9rem_1fr] md:grid-cols-[11rem_1fr] gap-1">
              <div>Finansiering:</div>
              <div>{customerAndParties?.commissionRemunerationDiscountFinancingMF?.value}</div>
              <div>Forsikring:</div>
              <div>{customerAndParties?.commissionRemunerationDiscountInsuranceMF?.value}</div>
              <div>Annoncering:</div>
              <div>{customerAndParties?.commissionRemunerationDiscountAnnouncementMF?.value}</div>
              <div>Andre yelser:</div>
              <div>{customerAndParties?.commissionRemunerationDiscountOthersMF?.value}</div>
            </div>
          </div>
          <div className="italic">
            Kontakt os for yderligere oplysninger omkring
            vederlagets/provisionens/rabattens størrelse
          </div>
        </div>
      </div>
    </div>
  );
};

export default DefaultPartner;
